import BaseModel from '../base/BaseModel.model';
import { PorposalExpectedResult } from '@/enums/PorposalExpectedResult';
export default class MultipleWaitinResult extends BaseModel {
    
    public expectedResult?: PorposalExpectedResult | null;
   public porposalId?: Number;

    init(){
      this.porposalId = undefined;
      this.expectedResult = null;
    }

}